import ErrorBoundary from 'components/ErrorBoundary'
import ReactStrapTable from 'components/reactStrapTable'
import React, { useState } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import ViewAuditToolTable from '../ViewAuditToolTable'
import Drawer from 'components/Drawer'
import AuditToolTable from '../AuditToolTable'
import Arrow from "assets/icon/Left-Chevron.svg";
import { dateFormate } from 'utils/columns'



const ViewAuditItems = (props) => {
    debugger;
    
    const [viewAudit , setViewAduit] = useState(false);

const {
  selectedRow,
  orgId,
  viewauditflag,
  setViewAuditflag,
  setLoading,
  loading,
  ceid,
  setCeid,onPageChange,filters,refetch
} = props;
    const toggleViewAudit = () => {
        setViewAduit(!viewAudit);
      };
      const handelAuditHistory = () => {
        setViewAuditflag(false);
        refetch(true);
      };

      
   
  return (
    <div>
      <Card className="border-0 shadow-top">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <Row>
              <div className="d-flex align-items-center">
                <h4
                  className="f-16 text-primary font-weight-700"
                  style={{ cursor: "pointer" }}
                  onClick={handelAuditHistory}
                >
                  <span
                    style={{
                      paddingRight: "5px",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <img style={{ width: "8px" }} src={Arrow} />
                  </span>{" "}
                  Audit Item
                </h4>
              </div>

              <Col md="4">
                <p className="m-0 f-14 mt-3">Audit Name :</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {selectedRow.auditName}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-3">From Date :</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {dateFormate(selectedRow.fromDate)}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-3">To Date :</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {dateFormate(selectedRow.toDate)}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-3">CoveredEntity :</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {selectedRow.coveredEntityName}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-3">Accumulator :</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {selectedRow.accumulatorName}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-3">Generated Date :</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {dateFormate(selectedRow.generatedDate)}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-3">Audit Count :</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {selectedRow.auditCount}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-3">Account Type :</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {selectedRow.accountType && selectedRow.accountType.split(',').join(' and ')}
                </p>
              </Col>
            </Row>
          </ErrorBoundary>
        </CardBody>
      </Card>
      <Card className="border-0 shadow-top mt-3">
        <CardBody>
          <AuditToolTable
            ceid={ceid}
            rowdata={selectedRow}
            orgId={orgId}
            setLoading={setLoading}
            loading={loading}
            onPageChange={onPageChange}
            filters={filters}
            refetch={refetch}
          />
        </CardBody>
      </Card>
    </div>
  );
}

export default ViewAuditItems